














































































import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter, Mutation } from 'vuex-class'
import VButton from '@/components/VButton.vue'
import VInput from '@/components/VInput.vue'
import * as types from '@/store/content/types'
import * as accountTypes from '@/store/account/types'
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue'
import SearchIcon from 'vue-material-design-icons/Magnify.vue'
import FormField from '@/utilities/validation/formfield'
import ClickOutside from 'vue-click-outside'

@Component({ components: { VButton, VInput, ChevronDown, ChevronUp, SearchIcon }, directives: { ClickOutside } })
export default class NavBar extends Vue {
  @Action('gradesTree', { namespace: 'content' }) private getGradesTree!: types.GradesTreeAction
  @Action('searchContent', { namespace: 'content' }) private searchContent!: types.SearchContentAction
  @Getter('gradesTree', { namespace: 'content' }) private gradesTree!: types.GradesTree
  @Getter('userInfo', { namespace: 'account' }) private userInfo!: accountTypes.AccountState
  @Mutation('LOGOUT', { namespace: 'account' }) private logout!: Function;

  private selectedCourses = []
  private selectedIndex = -1
  private selectedCourse = {}
  private showTree = false
  private searchText = new FormField(() => [], '')

  private created () {
    this.getGradesTree()
  }

  private goToBook (bookId: number) {
    this.$router.push(`/overview/${bookId}`)
  }

  private logoutAndGoToHome () {
    this.logout()
    this.$router.push({ name: 'home' })
  }
}
